import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import RegistarPedido from "../components/forms/RegistarPedido";
import useAxios from "../helpers/useAxios";
import { useKeycloak } from "@react-keycloak/web";

const Pedido = () => {
  const { keycloak } = useKeycloak();

  const [message, setMessage] = useState('');

  const { fetch, data, error, loaded } = useAxios("", "", {}, true);

  useEffect(() => {
    if (loaded && error.length === 0)
    {
      if (data === true)
      {
        setMessage("Pedido registado com sucesso.");

        window.scrollTo(0, 0);
      }
    }
  }, [data]);

  const onSubmitPedido = dataForm => {
    fetch("POST", "/User/create-ticket", {
      Name: keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name, 
      Email: keycloak.tokenParsed.email,
      nif: keycloak.tokenParsed.preferred_username,
      Subject: dataForm.assunto,
      Description: dataForm.descritivo,
      Type: 2,
    });
  }

 return (
  <div className="container-fluid mt-4 mb-3">
    <div className="row gx-4">
      <div className="col-md-3">
        <Navigation activeKey="/registarpedido" />
      </div>
      <div className="col-md-9">
        <h1 className="mt-4">Carteira</h1>
        <h2 className="mb-4">Registar pedido</h2>
        <RegistarPedido onSubmitHandler={onSubmitPedido} message={message} />
      </div>
    </div>
  </div>
 );
};

export default Pedido;
